export default function Option({ label, handleCheck, data }) {
    const isActive = data[label];
    return (
        <div className="flex items-center cursor-pointer w-full hover:bg-[#0e3372] hover:text-white transition duration-200"
            onClick={(label) => handleCheck(label)}
        >
            <label className="cursor-pointer mx-3 my-2" htmlFor="">{label}</label>
        </div>
    )
}